import { useState } from 'react';
import { rsme } from '../lib/rsme';
import { useQuery } from '../ui/useQuery';
import { PageHead, Card, Pill, Input, Loading, ErrorState, EmptyState } from '../ui/primitives';

export default function Certificates() {
  const [assetName, setAssetName] = useState('');
  const [certType, setCertType] = useState('');
  const [expiringSoon, setExpiringSoon] = useState(false);
  const q = useQuery(
    () => rsme.certificates.list({ assetName: assetName || undefined, certType: certType || undefined, expiringSoon }),
    [assetName, certType, expiringSoon],
  );

  return (
    <div className="max-w-5xl mx-auto">
      <PageHead title="Certificates" sub="LTA + every other expiring document" />
      <div className="px-5 md:px-8 flex flex-wrap gap-2 items-center">
        <Input value={assetName} onChange={(e) => setAssetName(e.target.value)} placeholder="Asset name" className="md:max-w-xs" />
        <Input value={certType} onChange={(e) => setCertType(e.target.value)} placeholder="Cert type" className="md:max-w-xs" />
        <label className="inline-flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" checked={expiringSoon} onChange={(e) => setExpiringSoon(e.target.checked)} className="accent-accent" />
          <span>Expiring in 30d</span>
        </label>
      </div>

      <div className="px-5 md:px-8 mt-4 space-y-2">
        {q.loading && <Loading rows={5} />}
        {q.error && <ErrorState error={q.error} retry={q.refetch} />}
        {!q.loading && !q.error && !q.data?.data?.length && <EmptyState title="No certificates match" />}
        {q.data?.data?.map((c) => (
          <Card key={c.id} className="!p-4">
            <div className="flex items-center gap-3 flex-wrap">
              <div className="min-w-0 flex-1">
                <div className="font-medium truncate">{c.assetName}</div>
                <div className="text-xs text-muted truncate">{c.certType} · #{c.certNumber ?? '—'} · issued {c.issuedDate ?? '—'} by {c.issuedBy ?? '—'}</div>
              </div>
              <Pill tone={expiringSoon ? 'warn' : 'muted'}>ends {c.coverageEnd ?? '—'}</Pill>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
